import {useNavigate, useParams} from "react-router-dom";
import React, {useMemo, useState} from "react";
import {Helmet} from "react-helmet";
import useGroupedAceLinks from "../../squadflixLiveView/useGroupedAceLinks";
import {Spinner, TitlePage} from "../../../shared";
import {isMobileDevice} from "../../../../utils/utils";
import LiveHlsPlayer from "../../squadflixVideoView/liveHlsPlayer/LiveHlsPlayer";
import {VlcUtils} from "../utils/vlcUtils";
import ItemsHorizontalScroll from "../../shared/itemsHorizontalScroll/itemsHorizontalScroll";
import ItemDetailsToView from "../../shared/itemDetailsView/itemDetailsToView";
import UseLiveCustomLinks from "../liveCustomLinks/hooks/useLiveCustomLinks";
import LiveStreamPlayer from "../../squadflixVideoView/liveStreamPlayer/liveStreamPlayer";
import ButtonV2 from "../../../shared/button-v2/button-v2";

const hlsUrl = "https://torresowo.myftp.org:9994/hls/manifest.m3u8?id=STREAM_ID";
const streamUrl = "https://torresowo.myftp.org:9994/hls/streamAceLink?id=STREAM_ID"

const LiveChannelDetails = ({acestreamLinks}) => {

    const id = useParams().id;
    const navigate = useNavigate();
    const [isFavorite, setIsFavorite] = useState((localStorage.getItem('favoriteAceLinks') ? JSON.parse(localStorage.getItem('favoriteAceLinks')) : []).some(link => link === id));
    const {links: customLinks} = UseLiveCustomLinks();
    const [streamMode, setStreamMode] = useState("stream");

    const {getChannelDetails, filteredLinks} = useGroupedAceLinks({aceLinks: acestreamLinks ?? []});

    const {channel, group} = useMemo(() => {
        if (!filteredLinks?.length) {
            const customLink = customLinks.find(link => link.id === id);

            if (customLink) {
                return {
                    channel: {
                        name: customLink.name,
                        url: customLink.link
                    },
                    group: {
                        name: "Tus LINKS",
                        icon: "https://play-lh.googleusercontent.com/daJbjIyFdJ_pMOseXNyfZuy2mKOskuelsyUyj6AcGb0rV0sJS580ViqOTcSi-A1BUnI",
                        links: customLinks
                    }
                };
            }

            return {channel: null, group: null};
        }

        return getChannelDetails(id);

    }, [id, getChannelDetails, filteredLinks, customLinks]);

    const handleSetFavourite = (channel) => {
        let favorites = localStorage.getItem('favoriteAceLinks') ? JSON.parse(localStorage.getItem('favoriteAceLinks')) : [];
        const exists = favorites.find(link => link === channel.url);
        if (exists) {
            favorites = favorites.filter(link => link !== channel.url);
            setIsFavorite(false);
        } else {
            favorites.push(channel.url);
            setIsFavorite(true);
        }
        localStorage.setItem('favoriteAceLinks', JSON.stringify(favorites));
    }

    if (!channel) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center text-center mt-5">
                <Spinner className="spinner-sm"/>
            </div>
        );
    }

    const otherStreams = () => {
        return (
            <ItemsHorizontalScroll>
                {group.links.map((link, index) => {
                    if (link.url === channel.url) {
                        return null;
                    }
                    return (
                        <ItemDetailsToView key={index} description={link.name} posterPath={group.icon} hover={false}
                                           aspectRatio="1/1" width={150}
                                           onClick={() => navigate("/squadflix/live/" + link.url ?? link.link)}></ItemDetailsToView>
                    )
                })}
            </ItemsHorizontalScroll>
        )
    }

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Live | {channel.name}</title>
                <link rel="icon" href={group.icon}/>
            </Helmet>
            <TitlePage leftClass="col-10" icon=""
                       rightClass="col-2"
                       disableScroll={true}
                       rightOptions={
                           <i className="fa-solid fa-xmark text-light fa-xl p-3" style={{
                               cursor: "pointer"
                           }} onClick={() => {
                               navigate("/squadflix/live");
                           }}></i>
                       }
                       title={
                           <div className="d-flex flex-row align-items-center">
                               <img style={{height: '3rem'}} className="image-border"
                                    src={group.icon}/>
                               <span className="ps-2">
                               {channel.name}
                               </span>
                           </div>
                       }></TitlePage>
            {streamMode === "hls" && <LiveHlsPlayer
                showDebugInfo={!isMobileDevice()}
                title={channel?.name || "AceStream Player"}
                className="ace-stream-video-player"
                autoPlay={true} muted={false}
                src={hlsUrl.replace("STREAM_ID", channel.url)}/>}
            {streamMode === "stream" && <LiveStreamPlayer
                title={channel?.name || "AceStream Player"}
                className="ace-stream-video-player"
                autoPlay={true} muted={false}
                otherStreams={otherStreams()}
                src={streamUrl.replace("STREAM_ID", channel.url)}/>
            }
            <div className="d-flex flex-row justify-content-end gap-3 pt-3 pb-3">
                <ButtonV2 size="small" onClick={() => {
                    if (streamMode === "hls") {
                        setStreamMode("stream");
                    } else {
                        setStreamMode("hls");
                    }
                }}>
                    {streamMode === "hls" &&
                        <span><i className="fa-solid fa-arrows-to-dot fa-lg"></i> Usar Stream</span>}
                    {streamMode === "stream" && <span><i className="fa-solid fa-wave-square fa-lg"></i> Usar HLS</span>}
                </ButtonV2>
                {acestreamLinks && <button
                    className="hlsbtn hlsbtn--external"
                    title="Añadir a favoritos"
                    onClick={() => handleSetFavourite(channel)}
                    aria-label="Añadir a favoritos">
                    {isFavorite && <i className="fa-solid fa-star text-warning fa-lg"></i>}
                    {!isFavorite && <i className="fa-regular fa-star fa-lg"></i>}
                </button>}
                <button
                    className="hlsbtn hlsbtn--vlc"
                    onClick={e => {
                        if (streamMode === "hls") {
                            VlcUtils.openInVlc(e, hlsUrl.replace("STREAM_ID", channel.url))
                        } else {
                            VlcUtils.openInVlc(e, streamUrl.replace("STREAM_ID", channel.url))
                        }
                    }}
                    title="Abrir en VLC"
                    aria-label="Abrir en reproductor VLC externo"
                >
                    <img src="https://cdn-icons-png.flaticon.com/512/732/732256.png" alt="vlc"
                         style={{maxWidth: "70%"}}/>
                </button>
            </div>
            <hr/>
            <TitlePage icon="fa-solid fa-link" title={"Grupo " + group.name} hideSeparator={true}
                       disableScroll={true}></TitlePage>
            <div className="pt-2">
                {otherStreams()}
            </div>
        </div>
    )
}

export default LiveChannelDetails;
